<template>
    <div id="newTaskModal" class="modal">
        <div class="modal-content">
             <div class="row">
                <div class="col offset-s11 s1 modal-close" style="text-align: right;"><i class="material-icons">close</i></div>
            </div>
            <template v-if="ntask">
            <div class="row">
                <div class="col s4 label rightalign">
                    <autosizelabel :text="$t('tasks.title')+':'" />
                    <select id="task_typeofselector" style="width: initial;" v-model='ntask.typeof' :disabled="!ntask.edit">
                        <option value="inspection">{{$t('tasks.kindnames.inspection')}}</option>
                        <option value="installation">{{$t('tasks.kindnames.installation')}}</option>
                        <option value="intervention">{{$t('tasks.kindnames.intervention')}}</option>
                        <option value="other">{{$t('tasks.kindnames.other')}}</option>
                    </select>
                </div>
                <div class="col s8" style="line-height: 3" v-if="(ntask.typeof == 'intervention' || ntask.typeof == 'other')">
                    <label>
                        <input type="checkbox" v-model="ntask.routine" :disabled="!ntask.edit" />
                        <span>{{$t('tasks.select_customer')}}</span>
                    </label>
                </div>
                <div class="col s4 input-field" style="margin-left: 10ch;" v-if="ntask.typeof == 'other'">
                    <input :placeholder="$t('tasks.task_name')" :disabled="!ntask.edit" v-model="ntask.typeof_other" />
                </div>
                <div class="col s4 input-field" v-if="ntask.typeof == 'installation'">
                    <select v-model="ntask.physical_mount" :disabled="!ntask.edit">
                        <option value="true">{{$t('installations.installation')}}</option>
                        <option value="false">{{$t('installations.system_enter')}}</option>
                    </select>
                </div>
            </div>
            <div class="row" v-if="ntask.typeof == 'inspection' || ntask.typeof == 'installation' || ntask.routine">
                <div class="col s8">
                    <autosizelabel :text="$t('tasks.place')" />
                    <div style="display: flex;" v-if="loaded">
                        <selector :items="customerItems" :singlemode="true" v-model="ntask.place_id" groupitems='places' :disabled="!ntask.edit" identifier="place">
                        </selector>
                    </div>
                </div>
            </div>
            <div class="row" v-if="(ntask.typeof == 'intervention' || ntask.typeof == 'other') && !ntask.routine">
                <div class="col s2 label">
                    {{$t('tasks.name')}}
                </div>
                <div class="col s10 input-field">
                    <input id="task_name" v-model="ntask.typeof_other" :disabled="!ntask.edit" />
                </div>
                <div class="col s2 label">
                    {{$t('tasks.reporter')}}
                </div>
                <div class="col s10 input-field">
                    <input id="task_address_name" v-model="ntask.address.name" :disabled="!ntask.edit" />
                </div>
            </div>
            <hr />
            <div class="row" v-if="(ntask.typeof == 'intervention' || ntask.typeof == 'other') && !ntask.routine">
                <div class="col s2 label">
                    {{$t('tasks.address.street')}}
                </div>
                <div class="col s8 input-field">
                    <input autocomplete="false" id="task_address_street" v-model="ntask.address.street" :disabled="!ntask.edit" />
                </div>
                <div class="col s2 input-field">
                    <input id="task_address_flatno" v-model="ntask.address.flatno" :disabled="!ntask.edit" placeholder="Nr. lokalu" />
                </div>
            </div>
            <div class="row" v-if="(ntask.typeof == 'intervention' || ntask.typeof == 'other') && !ntask.routine">
                <div class="col s2 label">
                    {{$t('tasks.address.postal_code')}}
                </div>
                <div class="col s2 input-field">
                    <input id="task_address_postalcode" v-model="ntask.address.postal_code" :disabled="!ntask.edit" />
                </div>
                <div class="col s2 label rightalign">
                    {{$t('tasks.address.city')}}
                </div>
                <div class="col s6 input-field">
                    <input id="task_address_city" v-model="ntask.address.city" :disabled="!ntask.edit" />
                </div>
            </div>
            <div class="row" v-if="(ntask.typeof == 'intervention' || ntask.typeof == 'other') && !ntask.routine">
                <div class="col s2 label">
                    {{$t('tasks.phone_number')}}
                </div>
                <div class="col s10 input-field">
                    <input id="task_phone" v-model="ntask.phone_number" :disabled="!ntask.edit" />
                </div>
            </div>
            <hr v-if="(ntask.typeof == 'intervention' || ntask.typeof == 'other') && !ntask.routine" />
            <div class="row" v-if="ntask.typeof == 'intervention'">
                <div class="col s3 label">{{$t('tasks.intervention_name')}}</div>
                <div class="col s3">
                    <select id="task_intervention_type" v-model='ntask.intervention_type' :disabled="!ntask.edit">
                        <option value="disinsection">{{$t('interventions.disinsection')}}</option>
                        <option value="disinfection">{{$t('interventions.disinfection')}}</option>
                        <option value="deratization">{{$t('interventions.deratization')}}</option>
                        <option value="other">{{$t('interventions.other')}}</option>
                    </select>
                </div>
                <div class="col s3 input-field" v-if="ntask.intervention_type == 'other'">
                    <input v-model="ntask.intervention_type_other" :disabled="!ntask.edit" />
                </div>
            </div>
            <div class="row" v-if="ntask.typeof == 'intervention'">
                <div class="col s2 label">{{$t('tasks.payment_method')}}</div>
                <div class="col s3"><select id="task_payment_method" v-model='ntask.payment_method' :disabled="!ntask.edit">
                        <option value="cash">{{$t('tasks.payment_methods.cash')}}</option>
                        <option value="transfer">{{$t('tasks.payment_methods.transfer')}}</option>
                        <option value="card">{{$t('tasks.payment_methods.card')}}</option>
                        <option value="blik">{{$t('tasks.payment_methods.blik')}}</option>
                    </select>
                </div>
                <div class="col s3 label">{{$t('tasks.pricing')}}</div>
                <div class="col s2 input-field"><input id="task_net_price" v-model="ntask.net_price" :disabled="!ntask.edit" /></div>
                <div class="col s2 input-field"><input id="task_pricing" v-model="ntask.pricing" :disabled="!ntask.edit" /></div>
            </div>
            <template v-if="ntask.typeof != 'inspection' && ntask.typeof != 'installation'">
                {{$t('tasks.reconescance')}}
                <textarea-autosize id="taskreconescance" :disabled="!ntask.edit" v-model="ntask.reconescance" :minHeight=32 />
            </template>

            {{$t('tasks.notices')}}
            <textarea-autosize  id="taskname" :disabled="!ntask.edit" v-model="ntask.name" :minHeight=32 />
             <template v-if="place != null && !loadingplace && ntask.typeof == 'inspection'" >
                <p> {{$t('tasks.last_inspection_notices')}}</p>
                <p>{{place.last_inspection_notices}}</p>
                <p> {{$t('tasks.inspection_schedule')}}</p>
                <p v-for="order in place.orders">
                    {{order.device_category_name}} {{humanizedTimeInterval(order.time_interval)}}
                </p>
                <p> {{$t("inspection_procedures.task_info") }}</p>
                <p>{{place.info}}</p>
            </template>
            <preloader v-if="loadingplace"/>
            <button class="btn-small green" v-on:click="addPhoto()" v-if="ntask.edit">{{$t('tasks.add_photo')}}<i class="material-icons">photo_library</i></button>
            <div class="row">
                <div class="col s4 label" v-for="(photo, index) in ntask.photos" style="padding: 15px;" v-show="photo.destroy != true">
                    <button class="removephoto" v-on:click="removePhoto(ntask, photo)" v-if="ntask.edit"><i class="material-icons">close</i></button>
                    <img :class="'photo'+index" style="height: 80px" />
                    <input type="file" id="photo" name="photo" multiple="true" @change="setFile(photo, $event.target.name, $event.target.files)" style="max-width: 100%;" v-if="!isFileSet(photo) && photo.image_url == undefined" accept="image/png, image/jpeg">
		<imagemagnify
                    v-if="photo.image_url"
                    :image="{ url: photo.image_url, thumb: { url: photo.image_url } }"
                    />                    
                </div>
            </div>
            <div class="row">
                <div class="col s1 label">{{$t('tasks.from')}}</div>
                <div class="col s5 input-field" style="display: inline-flex;">
                    <input type="date" id="dateStartsAt" :disabled="!ntask.edit" name="dateStartsAt" v-model="taskStartAtDate">
                    <vue-timepicker id="timeStartsAt" manual-input lazy hide-dropdown :disabled="!ntask.edit" v-model="taskStartAtTime" @focus="editdate = true" @blur="editdate = false" @open="editdate = true" @close="editdate = false" :minute-interval="5"></vue-timepicker>
                </div>
                <div class="col s1 label">{{$t('tasks.to')}}</div>
                <div class="col s5 input-field" style="display: inline-flex;" v-bind:class="errors.datestartafterend ? 'error' : ''">
                    <input type="date" id="dateEndsAt" :disabled="!ntask.edit" name="dateEndsAt" v-model="taskEndsAtDate">
                    <vue-timepicker id="timeEndsAt" manual-input lazy hide-dropdown :disabled="!ntask.edit" v-model="taskEndsAtTime" @focus="editdate = true" @blur="editdate = false" @open="editdate = true" @close="editdate = false" :minute-interval="5"></vue-timepicker>
                </div>
                <div class="col s12 error" v-if="errors.datestartafterend">Czas zakończenia zadania nie może być wcześniejszy niż czas rozpoczęcia</div>
            </div>
            <div class="row">
                <div class="col s2 label">
                    {{$t('tasks.workers')}}
                </div>
                <div class="col s7" v-if="workersLoaded">
                    <selector :disabled="!ntask.edit" v-model="ntask.worker_ids" :items="workerItems" identifier="newTaskWorkers"></selector>
                </div>
            </div>
            <div class="row">
                <div class="col s2 label">{{$t('tasks.status')}}</div>
                <div class="col s3">
                    <select id="taskstatusselect" v-model='ntask.status' :disabled="!ntask.edit">
                        <!-- <option label="Nowe" value="newtask">Nowe</option> -->
                        <option :label="$t('tasks.statuses.dateset')" value="dateset">{{$t('tasks.statuses.dateset')}}</option>
                        <option :label="$t('tasks.statuses.no_date')" value="no_date">{{$t('tasks.statuses.no_date')}}</option>
                        <option :label="$t('tasks.statuses.pending')" value="pending" selected="selected">{{$t('tasks.statuses.pending')}}</option>
                        <option :label="$t('tasks.statuses.finished_worker')" value="finished_worker">{{$t('tasks.statuses.finished_worker')}}</option>
                        <option :label="$t('tasks.statuses.cleared')" value="cleared">{{$t('tasks.statuses.cleared')}}</option>
                        <option :label="$t('tasks.statuses.refused')" value="refused">{{$t('tasks.statuses.refused')}}</option>
                    </select>
                </div>
            </div>
            <collapsible v-bind:title="$t('tasks.change_history')+' (' + ntask.versions.length + ')'" v-if="ntask.versions != undefined && ntask.id != undefined">
                <p v-for="version in ntask.versions">
                    {{{"create": $t('tasks.changes.create'), "update": $t('tasks.changes.update')}[version.event]}} {{version.name}} {{version.created_at | formatDateWithHour}}
                </p>
            </collapsible>
            <collapsible v-bind:title="$t('tasks.comments')+' (' + ntask.comments.length + ')'" v-if="ntask.comments != undefined && ntask.id != undefined">
                <div class="row" v-for="comment in ntask.comments" style="padding-top: 5px; padding-bottom: 5px;">
                    <div class="col s1">
                        <div class="circle" style="background-color: gray;">{{comment.initials}}</div>
                    </div>
                    <div class="col s8"> 
                        <input 
                          v-if="comment.editable" 
                          type="text"
                          v-model="comment.text" 
                          @blur="updateComment(comment)" 
                          style="flex: 1; min-width: 150px; border-bottom: none;"/>
                          <template v-else>{{comment.text}}</template>
                      </div>
                    <div class="col s1" v-if="comment.removable" v-on="deleteComment(comment)">X</div>
                    <!-- <div class="col s1">{{comment.editable}}</div> -->
                </div>
                <div class="row">
                    <div class="col s1">+</div>
                    <div class="col s8 input-field"><input type="text" v-model="newcomment" /></div>
                    <div class="col s2">
                        <a class="waves-effect waves-green btn-large white" v-on:click="addComment()">{{$t('tasks.add')}}</a>
                    </div>
                </div>
            </collapsible>
            </template>
        </div>
        <template v-if="ntask">
        <div class="modal-footer row" v-if="ntask.id == undefined">
            <div class="col offset-s4 s4">
                <a class="modal-close waves-effect waves-green btn-large grey">{{$t('tasks.cancel_task')}}</a>
            </div>
            <div class="col s4">
                <a v-on:click="saveTask()" class="waves-effect waves-green btn-large green" :disabled="errors.datestartafterend">
                    <div v-if="saving" class="preloader-wrapper small active">
                        <div class="spinner-layer spinner-red-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    {{ saving ? "" : $t('tasks.add_task')}}
                </a>
            </div>
        </div>
        <div class="modal-footer row" v-if="ntask.id != undefined && ntask.edit">
            <div class="col offset-s4 s4">
                <a class="modal-close waves-effect waves-green btn-large grey">{{$t('menu.buttons.cancel_changes')}}</a>
            </div>
            <div class="col s4">
                <a v-on:click="saveTask()" class="waves-effect waves-green btn-large green" :disabled="errors.datestartafterend">
                    <div v-if="saving" class="preloader-wrapper small active">
                        <div class="spinner-layer spinner-red-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    {{ saving ? "" : $t('menu.buttons.save_changes')}}
                </a>
            </div>
        </div>
        <div class="modal-footer row" v-if="ntask.id != undefined && !ntask.edit">
            <div class="col s2">
                <button class="waves-effect emptygreen btn-large white" v-on:click="cloneTask()">{{$t('menu.buttons.clone')}}</button>
            </div>
            <div class="col s2">
                <modal :question="$t('tasks.remove_question')" :confirmText="$t('menu.buttons.delete')" identifier="taskremovequestion" v-on:onConfirm="removeTask()" />
            </div>
            <div class="col s8">
                <button class="waves-effect waves-green btn-large white" v-on:click="editTask()">{{$t('menu.buttons.edit')}}</button>
            </div>
        </div>
        </template>
    </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
import 'moment/locale/pl'
export default {
    data: function() {
        return {
            newcomment: "",
            errors: {
                datestartafterend: false
            },
            saving: false,
            loadingplace: false,
            place: null
        }
    },
    mounted: function() {
        this.place = null
    },
    methods: {
        async addComment() {
            var response = await axios.post('/tasks/' + this.ntask.id + '/comments.json', { text: this.newcomment })
            this.ntask.comments.push(response.data)
            this.newcomment = ""
        },
        saveTask: async function(task) {
            if (this.saving == false) {
                this.saving = true;
                this.$emit('saveTask', task);
            }
        },
        deleteComment: function(comment) {
            var that = this;
            return {
                click: async function() {
                    await axios.delete('/tasks/' + that.ntask.id + '/comments/' + comment.id + '.json')
                    that.ntask.comments.splice(that.ntask.comments.indexOf(comment), 1)
                }
            }
        },
        updateComment: async function(comment) {
            await axios.put('/tasks/' + this.ntask.id + '/comments/' + comment.id + '.json', { text: comment.text })
        },

        removeTask: async function(task) {
            this.$emit('removeTask', this.ntask)
        },
        cloneTask: function() {
            this.$emit('cloneTask', this.ntask)
        },
        editTask: function() {
            this.ntask.edit = true;
        },
        addPhoto() {
            this.ntask.photos ||= [];
            this.ntask.photos.push({});
        },
        isFileSet(photo) {
            return _.isUndefined(photo.attachment) == false
        },
        setFile: function(doc, name, file) {
            var that = this;

            doc.attachment = file[0];
            var reader = new FileReader();

            reader.onload = function(event) {
                var dataUri = event.target.result;
                var img = document.getElementsByClassName('photo' + that.ntask.photos.indexOf(doc))[0];

                img.src = dataUri;
            };
            reader.onerror = function(event) {
                console.log("File could not be read: " + event.target.error.code);
            };
            reader.readAsDataURL(doc.attachment);
            if (file.length > 1) {
                for (var i in _.range(file.length)) {
                    if (i > 0) {
                        var ndoc = { timestamp: _.now() };
                        ndoc.attachment = file[i];
                        var reader = new FileReader();

                        reader.onload = function(event) {
                            var dataUri = event.target.result;
                            var img = document.getElementsByClassName('photo' + that.ntask.photos.indexOf(ndoc))[0];
                            img.src = dataUri;
                        };
                        reader.onerror = function(event) {
                            console.log("File could not be read: " + event.target.error.code);
                        };
                        reader.readAsDataURL(ndoc.attachment);

                        this.ntask.photos.push(ndoc)
                    }
                }
            }
        },
        removePhoto(task, photo) {
            if (_.isUndefined(photo.id)) {
                task.photos.splice(task.photos.indexOf(photo), 1)
            } else {
                photo.destroy = true;
                this.$forceUpdate();
            }
        },
        humanizedTimeInterval(timeInterval) {
          if (!timeInterval) return 'Invalid time interval';
          return moment.duration(timeInterval).humanize();
        }
    },
    props: { ntask: Object, workersLoaded: Boolean, workerItems: Array, customers: Array, loaded: Boolean },
    computed: {
        taskStartAtDate: {
            get: function() {
                return moment(this.ntask.startsAt).format("yyyy-MM-DD")
            },
            set: function(newVal) {
                console.log(newVal);
                var newDate = moment(newVal, "yyyy-MM-DD");
                if (newDate.isValid() && newVal != moment(this.ntask.startsAt).format("yyyy-MM-DD")) {
                    var newhour = moment(newVal, "yyyy-MM-DD");
                    this.ntask.startsAt = moment(this.ntask.startsAt).set({ date: newhour.get('date'), month: newhour.get('month'), year: newhour.get('year') }).format("yyyy-MM-DDTHH:mm")
                } else {
                    this.$forceUpdate();
                }
            }
        },
        taskStartAtTime: {
            get: function() {
                return moment(this.ntask.startsAt).format("HH:mm")
            },
            set: function(newVal) {
                var newDate = moment(newVal, "HH:mm");
                if (newDate.isValid() && newVal != moment(this.ntask.startsAt).format("HH:mm")) {
                    var newhour = moment(newVal, "HH:mm");
                    this.ntask.startsAt = moment(this.ntask.startsAt).set({ hour: newhour.get('hour'), minute: newhour.get('minute') }).format("yyyy-MM-DDTHH:mm")
                    this.$forceUpdate();
                }
            }
        },
        taskEndsAtDate: {
            get: function() {
                return moment(this.ntask.endsAt).format("yyyy-MM-DD")
            },
            set: function(newVal) {
                var newDate = moment(newVal, "yyyy-MM-DD");
                if (newDate.isValid() && newVal != moment(this.ntask.endsAt).format("yyyy-MM-DD")) {
                    var newhour = moment(newVal, "yyyy-MM-DD");
                    this.ntask.endsAt = moment(this.ntask.endsAt).set({ date: newhour.get('date'), month: newhour.get('month'), year: newhour.get('year') }).format("yyyy-MM-DDTHH:mm")
                } else {
                    this.$forceUpdate();
                }

            }
        },
        taskEndsAtTime: {
            get: function() {
                return moment(this.ntask.endsAt).format("HH:mm")
            },
            set: function(newVal) {
                if (newVal != moment(this.ntask.endsAt).format("HH:mm")) {
                    var newhour = moment(newVal, "HH:mm");
                    this.ntask.endsAt = moment(this.ntask.endsAt).set({ hour: newhour.get('hour'), minute: newhour.get('minute') }).format("yyyy-MM-DDTHH:mm")
                    this.$forceUpdate();
                }
            }
        },
        customerItems: {
            get: function() {
                var output = [];
                for (const customer of this.customers) {
                    if (customer.status == "active") {
                        var places = customer.places.filter((place) => place.status == "active");
                        if (places.length > 0) {
                            output.push({ "id": customer.id, "name": customer.name, "places": places });
                        }
                    }
                }
                return output;
            }
        },
        customerByPlaceIdItems: {
            get: function() {
                var output = {};
                for (const customer of this.customers) {
                    for (const place of customer.places) {
                        output[place.id] = customer.id;
                    }
                }
                return output;
            }
        },
        taskDurationItems: {
            get: function() {
                var output = {};
                  for (const customer of this.customers) {
                        if (customer.status == "active") {
                            var places = customer.places.filter((place) => place.status == "active");
                            for (const place of places) {
                                output[place.id] = place.estimated_time;
                            }
                            
                        }
                    }
                return output;
            }
        }
    },
    watch: {
        'ntask.startsAt': function(after, before) {
            if (this.ntask != null) {
                    var diffInHours = Math.abs(moment.duration(moment(this.ntask.endsAt, "yyyy-MM-DDTHH:mm").diff(moment(after, "yyyy-MM-DDTHH:mm"))).as('hours'));
                    if (Math.abs(diffInHours) > 24 || moment(after).isAfter(this.ntask.endsAt)) {
                        var newDate = moment(after, "yyyy-MM-DDTHH:mm");
                        var startsAt = moment(this.ntask.startsAt);
                        this.ntask.endsAt = moment(this.ntask.endsAt).set({ date: startsAt.get('date'), month: startsAt.get('month'), year: startsAt.get('year') }).format("yyyy-MM-DDTHH:mm")
                    }
                }
        },
        'ntask.endsAt': function(after, before) {
            if (this.ntask != null) {
                if (moment(after).isBefore(this.ntask.startsAt)) {
                    this.errors.datestartafterend = true;
                    var diffInHours = Math.abs(moment.duration(moment(this.ntask.startsAt, "yyyy-MM-DDTHH:mm").diff(moment(after, "yyyy-MM-DDTHH:mm"))).as('hours'));
                } else {
                    this.errors.datestartafterend = false;
                    this.$forceUpdate();
                }
            }
        },
        'ntask.place_id': function(after, before) {
            if(this.ntask){
                if(_.isUndefined(this.ntask.id) && after != before){
                    this.ntask.endsAt = moment(this.ntask.startsAt).add(_.max([this.taskDurationItems[after], 15]), 'minutes')
                }
                if(this.ntask.typeof == "inspection") {
                    this.loadingplace = true;
                    axios.get("/customers/"+this.customerByPlaceIdItems[after]+"/places/"+after+".json").then(response=>{
                        this.place = response.data;
                        this.loadingplace = false;
                    })
                }else{
                    this.place = null;
                }
            }
        }
    },

}
</script>
<style scoped>
.label {
    padding-top: 5px;
}
.removephoto {
    vertical-align: top;
    float: right;
    background-color: black;
    border: none;
    border-radius: 15px;

}

.removephoto i {
    color: white;
}

.emptygreen {
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
}

.modal {
    top: 2% !important;
    max-height: 100%;
    background-color: #dadada;
}

.modal .modal-footer {
    background-color: #dadada;
}

.modal .btn-large {
    border-radius: 8px;
    color: black;
}

.modal .green {
    margin-top: 10px;
    margin-bottom: 10px;
}

.error {
    color: red;
}

.circle {
    border-radius: 50%;
    width: 30px;
    height: 30px;
    line-height: 30px;
    background-color: #DADADA;
    text-align: center;
    display: inline-block;
}

/deep/ .error input {
    border-color: red !important;
}

.modal select {
    display: block !important;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
    height: 35px !important;
}

/deep/ .vue__time-picker input.display-time {
    border: 1px solid #d2d2d2;
    width: 10em;
    height: 2.2em;
    padding: 0.3em 0.5em;
    font-size: 1em;
}

/deep/ .vue__time-picker input {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    padding-left: 10px !important;
    padding-right: 0px !important;
    margin-left: 5px !important;
    margin-right: 10px !important;
}
</style>
